import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Button, Space, Spin, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { postRequest } from "../../../../../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../../../../utils/Notifications";
import { loadingIcon } from "../../../../../../utils/Helper";
import config from "../../../../../../Config";
const BulkProductUpload = ({
  facility_type_id,
  newProductAdded,
  setNewProductAdded,
  setCurrentTab,
}) => {
  const { t } = useTranslation();

  const [uploadFile, setUploadFile] = useState("");
  const [, setFileName] = useState(null);
  const [apiloading, setapiLoading] = useState(false);

  const handleUpload = async () => {
    try {
      const formData = new FormData();
      formData.append("product_list", uploadFile);
      setapiLoading(true);

      const apiResponse = await postRequest(
        "facility/upload-product/" + facility_type_id,
        formData
      );
      if (apiResponse.data.status) {
        SuccessNotificationMsg(t("msg_uploadSuccess"));
        setNewProductAdded(!newProductAdded);
        setCurrentTab((prevTab) => ({
          ...prevTab,
          // child1: false,
          child2: false, // Set child2 to false or adjust based on your requirement
        }));
      } else {
        ErrorNotificationMsg(t("err_uploadSuccess"));
      }
      setapiLoading(false);
    } catch (error) {
      setapiLoading(false);
      ErrorNotificationMsg(t("err_uploadSuccess"));
    }
  };

  const uploadProps = {
    accept: ".csv",
    showUploadList: false,
    beforeUpload: (file) => {
      setUploadFile(file);
      setFileName(file.name);
      return false;
    },
    onChange: handleUpload,
  };

  return (
    <div className="uploadwrap">
      <div className="uploadinside">
        <h5>
          {t("upload_excel_option")} (
          <a
            // href="https://pharmalinkage-dev-files.s3.ap-south-1.amazonaws.com/sample-files/API_Product_Sample.csv"
            href={`${config.BUCKET_URL}/sample-files/API_Product_Sample.csv`}
            className="link-color"
          >
            {t("download_sample_format")}
          </a>
          )
        </h5>
        <Upload {...uploadProps}>
          <Button type="primary" icon={<UploadOutlined />}>
            {t("upload")}
          </Button>
          <div className="condition">
            {" "}
            <p style={{ color: "GrayText" }}>{t("upload_fileSize")} (.csv)</p>
          </div>
        </Upload>
        <br />

        <Space size={[12, 16]}>
          {/* <span className="link-color">{fileName}</span> */}
          <br />
          <Spin spinning={apiloading} indicator={loadingIcon} />
        </Space>
      </div>
    </div>
  );
};

BulkProductUpload.propTypes = {
  facility_type_id: PropTypes.any, // Adjust the type as per your needs
  newProductAdded: PropTypes.bool,
  setNewProductAdded: PropTypes.func,
  setCurrentTab: PropTypes.func,
};

export default BulkProductUpload;
